import React, { useCallback, useState } from 'react';
import { Popover } from '@moda/om';
import { CountrySelector, useCountry, useSetCountry } from '../CountrySelector';
import { Country } from '../../constants';

import './SitePromoBannerCountrySelector.scss';

export const SitePromoBannerCountrySelector: React.FC = () => {
  const { country } = useCountry();
  const { setCountry } = useSetCountry();

  const [open, setOpen] = useState(false);

  const handleSelect = useCallback(
    (country: Country) => {
      setCountry(country);
      setOpen(false);
    },
    [setCountry]
  );

  const handleMouseEnter = useCallback(() => setOpen(true), []);
  const handleMouseLeave = useCallback(() => setOpen(false), []);

  return (
    <Popover
      className="SitePromoBannerCountrySelector"
      open={open}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      content={
        <CountrySelector
          className="SitePromoBannerCountrySelector__selector"
          onSelect={handleSelect}
        />
      }
    >
      <>
        Currency: {country.alpha3Code} ({country.currencyCode})
      </>
    </Popover>
  );
};
